<div class="menu-wrapper">
  <div class="menu-label-wrapper">APP Navigation</div>
  <button mat-menu-item [routerLink]="['/calendar']" *ngIf="application.isTrainerLogin()">
    <mat-icon color="{{application.state=='big_calendar' ? 'accent' : ''}}">date_range</mat-icon>
    <span [class.selected]="application.state=='big_calendar'">Calendar</span>
  </button>
  <button mat-menu-item [routerLink]="['/clients']" *ngIf="application.isTrainerLogin()">
    <mat-icon color="{{application.state=='clients' ? 'accent' : ''}}">group</mat-icon>
    <span [class.selected]="application.state=='clients'">Users/Clients</span>
  </button>
<!--  <button mat-menu-item [routerLink]="['/referrals']" *ngIf="application.isTrainerLogin()">-->
<!--    <mat-icon color="{{application.state=='referrals' ? 'accent' : ''}}">group</mat-icon>-->
<!--    <span [class.selected]="application.state=='referrals'">Referrals</span>-->
<!--  </button>-->
  <button mat-menu-item [routerLink]="['/articles/folders']">
    <mat-icon color="{{(['articles_folders','articles'].indexOf(application.state) !== -1) ? 'accent' : ''}}">school</mat-icon>
    <span [class.selected]="(['articles_folders','articles'].indexOf(application.state) !== -1)">Courses</span>
  </button>
<!--  <button mat-menu-item [routerLink]="['/workouts']">-->
<!--    <mat-icon color="{{application.state=='workouts' ? 'accent' : ''}}">fitness_center</mat-icon>-->
<!--    <span [class.selected]="application.state=='workouts'">Workouts</span>-->
<!--  </button>-->
<!--  <button mat-menu-item [routerLink]="['/recipes']">-->
<!--    <mat-icon color="{{application.state=='recipes' ? 'accent' : ''}}">local_dining</mat-icon>-->
<!--    <span [class.selected]="application.state=='recipes'">Recipes</span>-->
<!--  </button>-->
  <button mat-menu-item [routerLink]="['/reports']" *ngIf="application.isOwnerLogin()">
    <mat-icon color="{{application.state=='reports' ? 'accent' : ''}}">bar_chart</mat-icon>
    <span [class.selected]="application.state=='reports'">Reports</span>
  </button>
  <hr>
  <a mat-menu-item href="/ng-panel/calendar" *ngIf="application.isTrainerLogin()">
    <mat-icon>open_in_new</mat-icon>
    <span [class.selected]="application.state=='clients'">Нова панель</span>
  </a>
</div>
